'use client'

// React Imports
import { createContext, useCallback, useMemo, useState } from 'react'

const VerticalNavContext = createContext({})

export const VerticalNavProvider = ({ children }) => {
  // States
  const [verticalNavState, setVerticalNavState] = useState({
    isCollapsed: false,
    isHovered: false
  })

  // Hooks
  const updateVerticalNavState = useCallback(values => {
    setVerticalNavState(prevState => ({
      ...prevState,
      ...values
    }))
  }, [])

  const toggleVerticalNav = useCallback(value => {
    setVerticalNavState(prevState => ({
      ...prevState,
      isToggled: value !== undefined ? Boolean(value) : !Boolean(prevState?.isToggled)
    }))
  }, [])

  const toggleCollapsed = useCallback(value => {
    setVerticalNavState(prevState => ({
      ...prevState,
      isCollapsed: value !== undefined ? Boolean(value) : !Boolean(prevState?.isCollapsed)
    }))
  }, [])

  const updateHoverState = useCallback(value => {
    setVerticalNavState(prevState => ({
      ...prevState,
      isHovered: value !== undefined ? Boolean(value) : !Boolean(prevState?.isHovered)
    }))
  }, [])

  const verticalNavProviderValue = useMemo(
    () => ({
      ...verticalNavState,
      updateVerticalNavState,
      toggleVerticalNav,
      toggleCollapsed,
      updateHoverState
    }),
    [verticalNavState, updateVerticalNavState, toggleVerticalNav, toggleCollapsed, updateHoverState]
  )

  return <VerticalNavContext.Provider value={verticalNavProviderValue}>{children}</VerticalNavContext.Provider>
}

export default VerticalNavContext
